import axios from 'axios';
import { starter2Api } from '../constants/Endpoint';
import { adios } from '@adserve/adserve-react-components';

export const GetDealDiscounts = async (dealVersionId) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/DealVersion/${dealVersionId}/DealDiscounts`)
    );
    return results.data.data;
};

export const GetDealDto = async (dealVersionId) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/DealVersion/${dealVersionId}/dto`)
    );
    return results.data;
};
